<template>
    <div>
        <!-- 账户 -->
        <div class="account">
            <div @click="selectAccount()">
                <Button type="primary" @click="modal = true" v-hasPermission="['permissionsConfigurationManagement:resourcePermission:add_account']">{{$t('permission_configuration_management.group.addAccount')}}</Button>
            </div>
        </div>
        <Modal v-model="modal" :title="$t('permission_configuration_management.group.addAccount')" width="900px;" :loading="modalLoading" :ok-text="$t('permission_configuration_management.common.cancel')" :mask-closable="false" :closable="false">
            <div slot="footer">
                <Button @click="cancel()">{{$t('permission_configuration_management.common.cancel')}}</Button>
                <Button type="primary" @click="handleSubmit()" :loading="addloading" :disabled="isDisable">{{$t('permission_configuration_management.common.confirm')}}</Button>
            </div>
            <Table :no-data-text="$t('common.noData')" ref="selection" :columns="columns" :loading="loading" :data="queryAccountData" :height="400" @on-selection-change="getSelection"></Table>
        </Modal>
        <table-account ref="tableAccountChild"></table-account>
    </div>
</template>

<script>
    import {getCookie} from '../../../../utils/cookieUtil.js'
    import TableAccount from '../resource_permission/TableAccount'

    var tableAccount = TableAccount;
    export default {
        name: 'AddAccount',
        components: {
            TableAccount
        },
        data() {
            return {
                isDisable: true,
                selection: [],
                modal: false,
                modalLoading: true,
                loading: false,
                addloading:false,
                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: this.$t('permission_configuration_management.group.accountName'),
                        key: 'name'
                    },
                    {
                        title:this.$t('permission_configuration_management.group.accountType'),
                        key:'accountTypeName'
                    },
                    {
                        title: this.$t('permission_configuration_management.group.accountId'),
                        key: 'accountId'
                    }
                ],
                queryAccountData: [],
                newQueryAccountList:[]
            }
        },
        methods: {
            // 父组件调用子组件table内的方法
            queryAccountByGroupId(){
                this.$refs.tableAccountChild.queryAccountByGroupId();
            },
            selectAccount: function () {
                this.$api.groupAccountRelation.queryAccount("groupId", this.$route.query.id)
                    .then(res => {
                        this.queryAccountData = res.data;
                        tableAccount.methods.showAll();
                    })
            },
            // 当前选择checkbox
            getSelection: function (selection) {
                this.selection = selection;
                // 清空数组
                this.newQueryAccountList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    this.newQueryAccountList.push(this.selection[i].id);
                }
                // 选了数据 可以点击下一步
                if (this.newQueryAccountList.length == 0) {
                    this.isDisable = true;
                } else {
                    this.isDisable = false;
                }
            },
            // 添加
            handleSubmit: function () {
                this.addloading=true;
                this.$api.groupAccountRelation.createAccountRelation({
                    "groupId": this.$route.query.id,
                    "accountIdList":this.newQueryAccountList
                }).then(res => {
                    setTimeout(() => {
                        tableAccount.methods.showAll();
                        this.modalLoading = false;
                        this.$nextTick(() => {
                            this.modalLoading = true;
                        });
                        this.$Message.success(this.$t('common.addSuccess'));
                        this.queryAccountData=[];
                        this.newQueryAccountList=[];
                        this.modal = false;
                        this.isDisable = true;
                        this.addloading=false;
                    }, 1000);
                })
            },
             // 取消
            cancel: function () {
                this.isDisable = true;
                this.modal = false;
                this.queryAccountData=[];
                this.newQueryAccountList=[];
            }
        }
    }
</script>

<style scoped>
  /*account*/
  .account {
    width: 100%;
    margin-bottom: 10px;
    overflow: hidden;
  }

  .account>div:nth-child(1) {
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/AddAccount.vue